/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */

import * as SG from '../snap_helper';

export class SearchByBBOXControl extends  SG.SelectionControl {
    snapGlobeMenu;
    snapResults;

    constructor(snapGlobeMenu, snapResults) {

        super({
            btnId: 'og-globus-menu-selection',
            ignoreTerrain: true,
            autoSelectionHide: false,
            onSelect: function (extent) {

                let singlePoint = false;
                if (extent[1] === extent[3]) {
                    extent[1] -= 0.1;
                    extent[3] += 0.1;
                    singlePoint = true;
                }

                if (extent[0] === extent[2]) {
                    extent[0] -= 0.1;
                    extent[2] += 0.1;
                    singlePoint = true;
                }
                let dx = extent[2] - extent[0];
                let dy = extent[3] - extent[1];
                let ratio = dy / dx;
                let h = 10;
                let w = 10;
                let x = 5;
                let y = 5;
                if (!singlePoint) {
                    this._planet.viewExtentArr(extent);
                    let bbox = extent;
                    let params = {
                        minLon: bbox[0],
                        minLat: bbox[1],
                        maxLon: bbox[2],
                        maxLat: bbox[3],
                        srid: 3857
                    };

                }

                let apiSearch = 'https://snapglobe.ogs.it/joomla/api/sg/search?bbox=' + extent.join('_');

                fetch(apiSearch).then(async (dataPromise) => {
                    let response = await dataPromise;
                    let results = await response.json();
                    snapResults.update(results.data.attributes);
                });

                snapGlobeMenu.reset();
            }
        });

        this.snapGlobeMenu = snapGlobeMenu;
        this.snapResults = snapResults;



    }
}
